import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class TextVerticalAlign extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, TextVerticalAlign._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static toCssAlignItemsString(value:TextVerticalAlign):'flex-start' | 'center' | 'flex-end' | 'baseline'
    {
        if( TextVerticalAlign.isTop(value) )
            return 'flex-start';
        if( TextVerticalAlign.isMiddle(value) )
            return 'center';
        if( TextVerticalAlign.isBottom(value) )
            return 'flex-end';
        if( TextVerticalAlign.isBaseline(value) )
            return 'baseline';

        return 'flex-start';
    }

    public static toCssBackgroundPositionString(value:TextVerticalAlign):string
    {
        if( TextVerticalAlign.isMiddle(value) )
            return 'center';

        return value.toString();
    }

    public static TOP = new AString('top');
    public static MIDDLE = new AString('middle');
    public static BOTTOM = new AString('bottom');
    public static BASELINE = new AString('baseline');

    private static _types:Array<AString> = [
        TextVerticalAlign.TOP,
        TextVerticalAlign.MIDDLE,
        TextVerticalAlign.BOTTOM,
        TextVerticalAlign.BASELINE,
    ];

    public static isTop(verticalAlign:TextVerticalAlign):boolean
    {
        return verticalAlign && TextVerticalAlign.TOP.isEqualTo(verticalAlign.value);
    }

    public static isBottom(verticalAlign:TextVerticalAlign):boolean
    {
        return verticalAlign && TextVerticalAlign.BOTTOM.isEqualTo(verticalAlign.value);
    }

    public static isMiddle(verticalAlign:TextVerticalAlign):boolean
    {
        return verticalAlign && TextVerticalAlign.MIDDLE.isEqualTo(verticalAlign.value);
    }

    public static isBaseline(verticalAlign:TextVerticalAlign):boolean
    {
        return verticalAlign && TextVerticalAlign.BASELINE.isEqualTo(verticalAlign.value);
    }

    public static top():TextVerticalAlign
    {
        return new TextVerticalAlign(TextVerticalAlign.TOP);
    }

    public static middle():TextVerticalAlign
    {
        return new TextVerticalAlign(TextVerticalAlign.MIDDLE);
    }

    public static bottom():TextVerticalAlign
    {
        return new TextVerticalAlign(TextVerticalAlign.BOTTOM);
    }

    public static baseline():TextVerticalAlign
    {
        return new TextVerticalAlign(TextVerticalAlign.BASELINE);
    }

    public static fromString(value:string):TextVerticalAlign
    {
        return new TextVerticalAlign(AString.fromString(value));
    }
}
